<div class="mainColumn">

	<div class="theCard">

		<div class="theLogo">

			<a
				[routerLink]="['/auth/login']"
				title="Startseite"
			>
				<img
					[src]="logoSrc || 'assets/logo.png'"
					style="max-width: 100%; margin: 0 0 2em 0; mix-blend-mode: darken;"
				>
			</a>
			
		</div>

		<div>
			2 Faktor Authentifizierung
		</div>

        <app-manage-2fa [user]="_user"></app-manage-2fa>

		
	</div>

</div>
